export const CLIENT_CODE_STYLES_CONFIG = {
  "demo": {
    defaultTheme: "demo",
    loadLocalStyles: () => import("@/custom/styles/demo/demo.theme.scss"),
  },
  "demo2": {
    defaultTheme: "demo2",
    loadLocalStyles: () => import("@/custom/styles/demo2/demo2.theme.scss"),
  },
  "lid": {
    defaultTheme: "lidingo-light",
    loadLocalStyles: () => import("@/custom/styles/lid/lidingo-light.theme.scss"),
  },
  "lin": {
    defaultTheme: "linkoping-light",
    loadLocalStyles: () => import("@/custom/styles/lin/linkoping-light.theme.scss"),
  },
  "ron": {
    defaultTheme: "ronneby-light",
    loadLocalStyles: () => import("@/custom/styles/ron/ronneby-light.theme.scss"),
  },
  "tro": {
    defaultTheme: "trollhattan-light",
    loadLocalStyles: () => import("@/custom/styles/tro/trollhattan-light.theme.scss"),
  }
};
